import React from 'react'
import styles from './styles.module.scss'
import ToggleSwitch from 'srcReact/components/common2/ToggleSwitch'

export const ToggleSettings = ({ title = '', subTitle = '', options = [] }) => {
  return (
    <div className={styles.toggleSettings}>
      <div className={`${styles.headerBlock}`}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subTitle}>{subTitle}</p>
      </div>
      {options?.map((option) => (
        <div className={styles.toggleBlock}>
          <ToggleSwitch isChecked={option.isChecked} onChange={option.onChange} stopPropagation={true} />
          <div className={`${styles.textBlock}`}>
            <h2 className={styles.title}>{option.title}</h2>
            {option.subTitle && <p className={styles.subTitle}>{option.subTitle}</p>}
          </div>
        </div>
      ))}
    </div>
  )
}
